export { typedArrayLength } from "#typed-array-length";
